<script>
/* eslint-disable */
import { mapGetters } from "vuex"
import Draggable from 'vuedraggable'
import { v4 as uuidv4 } from 'uuid'
import Move from "./Move.vue";
import DynamicItem from "./DynamicItem.vue"

const setDragCursor = value => {
  const html = document.getElementsByTagName('html').item(0)
  html.classList.toggle('grabbing', value)
}

export default {
  props: ['circuit'],
  name: "CircuitList",
  components: {
    Move,
    DynamicItem,
    Draggable
  },
  data(){
    return {
      work: this.circuit.work,
      rest: this.circuit.rest,
      items: this.circuit.items,
      selected: false,
    }
  },
  watch: {
    circuit(newCircuit){
      this.items = newCircuit.items
      console.log(this.items)
    },
    items(){
      this.$store.dispatch('scripts/updateCircuitList', {circuitId: this.circuit.id, items: this.items})
    },
    selected(newVal){
      if (newVal) {
        this.$store.dispatch('scripts/pushSelectedCircuit', this.circuit.id)
      }
      else {
        this.$store.dispatch('scripts/popSelectedCircuit', this.circuit.id)
      }
    }
  },
  computed: {
    ...mapGetters({
      scriptOpened: "scripts/scriptOpened",
      hasMoreThanOneCircuits: "scripts/hasMoreThanOneCircuits",
    }),
    fillerList:{
      get(){
        const items = this.items
        const newItems = []
        if (items.length < 9) {
          const diff = 9 - items.length
          for (let i=0;i<diff;i++) {
            newItems.push({type: 'filler', id: uuidv4()})
          }
        }
        return newItems
      },
    }
  },
  methods: {
    onDragStart() {
      setDragCursor(true)
    },
    onDragEnd() {
      setDragCursor(false)
    },
  }
  
};
</script>


<style scoped>
.circuit-list {
  border-top: 5px solid #707070;
  margin: 0;
  padding: 0;
  position: relative;
}
.pointer {
  position: absolute;
  top: 200px;
  left: 40vw;
}
.note {
  position: absolute;
  top: 120px;
  left: 40vw;
  text-align: center;
}
.works-reps {
  position: absolute;
  top: 16px;
  right: 0;
  width: 250px;
}

.reps{
  font-family: 'Times New Roman', Times, serif;
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: -5px;
  text-align: right;
}

.checkbox .round {
  margin-left: 1rem;
}

.separator {
  display: flex;
  justify-content: center;
  align-items: center;
}
.separator span {
  font-weight: 600;
  font-size: 20px;
}
</style>

<template>
  <div class="circuit-list">
    <div class="note" v-if="circuit.items.length === 0 && !hasMoreThanOneCircuits">
      <h3>This circuit is empty</h3>
      <p>Start adding a move or an instruction below.</p>
    </div>
    <div v-if="circuit.items.length === 0">
      <move></move>
      <move></move>
      
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
      <move v-if="!hasMoreThanOneCircuits"></move>
    </div>
    <div v-else>
      <move></move>
      <move></move>
      <draggable v-model="items" @start="onDragStart" @end="onDragEnd">
        <dynamic-item v-for="item in items" :key="item.id" :item="item" :circuit="circuit"></dynamic-item>
      </draggable>
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.934"
      height="217.58"
      viewBox="0 0 26.934 217.58"
      class="pointer"
      v-if="circuit.items.length === 0 && !hasMoreThanOneCircuits"
    >
      <g
        id="Dotted_arrow_down"
        data-name="Dotted arrow down"
        transform="translate(772.556 876) rotate(180)"
      >
        <g
          id="Polygon_1"
          data-name="Polygon 1"
          transform="translate(745.622 662.183) rotate(-20)"
          fill="#fff"
        >
          <path
            d="M 10.15436172485352 9.5 L 0.8456379771232605 9.5 L 5.5 1.037523627281189 L 10.15436172485352 9.5 Z"
            stroke="none"
          />
          <path
            d="M 5.5 2.075047492980957 L 1.691275596618652 9 L 9.308724403381348 9 L 5.5 2.075047492980957 M 5.5 0 L 11 10 L 0 10 L 5.5 0 Z"
            stroke="none"
            fill="#000"
          />
        </g>
        <path
          id="Path_272"
          data-name="Path 272"
          d="M0,206.3s17.556-40.313,17.556-91.888S0,0,0,0"
          transform="translate(754.5 669.5)"
          fill="none"
          stroke="#000"
          stroke-width="1"
          stroke-dasharray="5"
        />
      </g>
    </svg>
    <div class="works-reps">
      <div class="row no-gutters">
        <div class="col-md-8 offset-md-2" v-if="circuit.type=='timer'">
          <div class="row no-gutters">
            <div class="col-md-5">
              <b-form-input v-model="work"></b-form-input>
            </div>
            <div class="col-md-2 separator">
              <span>/</span>
            </div>
            <div class="col-md-5">
              <b-form-input v-model="rest"></b-form-input>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2" v-else>
          <div class="row no-gutters">
            <div class="col-md-5 offset-md-7 reps">
              REPS
            </div>
          </div>
        </div>
        
        <div class="col-md-2 checkbox">
          <div class="round">
            <input type="checkbox" :id="'checkbox'+circuit.id" v-model="selected"/>
            <label :for="'checkbox'+circuit.id"></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>